<template>
  <div id="app-center">
    <my-head></my-head>
    <center-head></center-head>
    <div class="center-box">
      <div class="center-list">
        <el-row :gutter="30">
          <el-col :span="4">
            <left-menu></left-menu>
          </el-col>

          <el-col :span="20">
            <div class="center-left">
              <el-card>
                <el-input
                  v-model="search.project_name"
                  placeholder="请输入项目名称"
                  size="small"
                  style="width: 200px"
                ></el-input>

                <el-select
                  v-model="search[status_info.param]"
                  placeholder="状态"
                  style="width:200px"
                  size="small"
                  clearable
                >
                  <el-option
                    el-option
                    :label="item.value"
                    :value="item.key"
                    v-for="(item,index) in status_info.values"
                    :key="index"
                  ></el-option>
                </el-select>

                <el-input
                  v-model="search.user_name"
                  placeholder="请输入申请人"
                  size="small"
                  style="width: 200px"
                ></el-input>
                <el-button
                  type="primary"
                  size="small"
                  icon="el-icon-search"
                  @click="$refs['tables'].handleSearch()"
                >搜索</el-button>
              </el-card>

              <WtDataTable
                ref="tables"
                :search="search"
                :listUrl="$db.config.cf_project.apply.list"
              >
                <div slot="buttons">
                  <el-button
                    size="small"
                    style="margin:0px 0px 10px;"
                    type="primary"
                    icon="el-icon-plus"
                    @click="cfProApply"
                  >申请</el-button>
                </div>
                <template slot="columns">
                  <el-table-column label="序号" prop="key" min-width="65" align="center">
                    <template slot-scope="scope">{{scope.row.key}}</template>
                  </el-table-column>
                  <el-table-column label="申请人" align="center" min-width="150" prop="user_name">
                    <template slot-scope="scope">
                      <a
                        href="javascript:;"
                        @click="goUserDetail(scope.row)"
                      >{{scope.row.user_name}}</a>
                      <!-- <router-link
                        :to="'/cfProjectApplyInfo?id='+scope.row.id"
                      >{{scope.row.user_name}}</router-link>-->
                    </template>
                  </el-table-column>

                  <el-table-column label="项目名称" align="center" prop="project_name" min-width="300">
                    <template slot-scope="scope">
                      <a href="JavaScript:;" @click="goDetail(scope.row)">{{scope.row.project_name}}</a>
                    </template>
                  </el-table-column>

                  <el-table-column label="申请时间" prop="regtime" align="center" min-width="100"></el-table-column>

                  <el-table-column
                    label="救助状态"
                    prop="audit_result_text"
                    align="center"
                    min-width="100"
                  >
                    <template slot-scope="scope">
                      <span
                        style="color:red;text-decoration: underline; cursor: pointer;"
                        v-if="scope.row.audit_result == 2"
                      >
                        <el-popover
                          placement="top"
                          title="审核意见："
                          width="200"
                          trigger="click"
                          :content="scope.row.audit_opinion"
                        >
                          <span slot="reference">{{scope.row.audit_result_text}}</span>
                        </el-popover>
                      </span>
                      <span v-else>{{scope.row.audit_result_text}}</span>
                    </template>
                  </el-table-column>

                  <!-- <el-table-column label="拨款状态" prop="status_text" align="center" min-width="100">
                    <template slot-scope="scope">
                      <span
                        style="color:red;text-decoration: underline; cursor: pointer;"
                        v-if="scope.row.status_audit_opinion || scope.row.status == 2"
                      >
                        <el-popover
                          placement="top"
                          title="审核意见："
                          width="200"
                          trigger="click"
                          :content="scope.row.status_audit_opinion"
                        >
                          <span slot="reference">{{scope.row.status_text}}</span>
                        </el-popover>
                      </span>
                      <span v-else>{{scope.row.status_text}}</span>
                    </template>
                  </el-table-column>-->
                  <el-table-column label="操作" width="380" align="center">
                    <template slot-scope="scope">
                      <el-button-group>
                        <el-button
                          type="primary"
                          icon="el-icon-edit"
                          size="mini"
                          :disabled="(scope.row.audit_result == 1 || scope.row.is_node == 1)?true:false"
                          @click="edit(scope.row.id)"
                        >编辑</el-button>
                        <el-button
                          type="danger"
                          icon="el-icon-delete"
                          size="mini"
                          :disabled="(scope.row.audit_result == 1)?true:false"
                          @click="handleDelete(scope.row)"
                        >删除</el-button>
                      </el-button-group>
                    </template>
                  </el-table-column>
                </template>
              </WtDataTable>
            </div>
          </el-col>
        </el-row>
      </div>

      <info v-if="if_open4" v-model="if_open4" :id="apply_id" @success="success"></info>

      <detail v-if="if_open" v-model="if_open" :pid="project_id" :aid="project_apply_id"></detail>
      <media
        v-if="if_open1"
        v-model="if_open1"
        :title="media_title"
        :aid="apply_id"
        :id="project_id"
        :type="2"
      ></media>

      <visit v-if="if_open2" v-model="if_open2" :title="visit_title" :id="apply_id"></visit>

      <apply-detail v-if="if_open3" v-model="if_open3" :id="apply_id"></apply-detail>

      <foot-div></foot-div>
    </div>
  </div>
</template>
<script>
import myHead from "../../public/head";
import centerHead from "../../public/center_head";
import leftMenu from "../../public/menu";
import footDiv from "../../public/foot";
import detail from "../info/detail";
import media from "../info/media";
import visit from "./visit_list";
import applyDetail from "./detail";
import info from "./info";

export default {
  components: {
    myHead,
    centerHead,
    leftMenu,
    footDiv,
    detail,
    media,
    visit, //回访记录列表
    applyDetail, //申请记录信息
    info
  },
  data() {
    return {
      if_open: false,
      project_id: null,
      project_apply_id: null,

      status_info: { param: null, values: [] }, //筛选状态

      if_open3: false, //申请人信息
      if_open4: false, //救助申请info

      if_open1: false, //媒体报道
      media_title: null,
      apply_id: null,

      if_open2: false, //回访记录
      visit_title: {
        user_name: null,
        project_name: null
      }, //

      statusId: 0,
      tableData: [],
      payForm: {}, //捐款申请数据
      pageSize: 15,
      search: {},
      auditText1: null,
      auditText2: null
    };
  },
  methods: {
    //查看项目详情
    goDetail(row) {
      this.project_id = row.project_id;
      this.project_apply_id = row.project_apply_id;
      this.if_open = true;
    },

    //获取筛选下拉选择
    getStatusInfo() {
      this.$db
        .post(this.$db.config.cf_project.info.status_info, {
          name: "CROWD_APPLY_INFO_AUDIT"
        })
        .then(res => {
          this.status_info = res.data;
        });
    },

    //获取申请人详情
    goUserDetail(row) {
      this.apply_id = row.id;
      this.if_open3 = true;
    },

    //操作媒体报道
    doMedia(row) {
      this.project_id = row.project_id;
      this.apply_id = row.id;
      this.media_title = row.user_name;
      this.if_open1 = true;
    },

    //点击申请
    cfProApply() {
      this.apply_id = null;
      this.if_open4 = true;
    },

    //提交走访记录
    doVisit(row) {
      this.apply_id = row.id;
      this.visit_title.project_name = row.project_name;
      this.visit_title.user_name = row.user_name;
      this.if_open2 = true;
    },

    //编辑操作
    edit(id) {
      this.apply_id = id;
      this.if_open4 = true;
    },

    //新增编辑回调
    success() {
      this.$refs.tables.reloadData();
    },

    //提交捐款凭证操作
    submitForm() {
      if (!(this.payImgArr.length > 0)) {
        return this.$message.warning("请上传捐款凭证！");
      } else {
        this.payForm.org_payment_pic = this.payImgArr;
      }
      let url;
      let page;
      this.$refs["payRef"].validate(valid => {
        if (valid) {
          if (this.payForm.funds_id) {
            url = this.$db.config.updatePayFunds;
            page = this.curPage;
          } else {
            page = 1;
            url = this.$db.config.submitPayFunds;
          }
          this.$db.post(url, this.payForm).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.addPaymentModal = false;
              return this.getConfirmPayList(page);
            } else {
              return this.$message.warning(res.msg);
            }
          });
        } else {
          this.$message.warning("请填写完整信息！");
        }
      });
    },

    //删除信息
    handleDelete(row) {
      if (row.audit_result == 1 || !row.id) {
        return this.$message.warning("参数错误！");
      } else {
        this.$confirm("此操作将永久删除该申请记录, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.$db
              .post(this.$db.config.deleteProjectApply, { ids: row.id })
              .then(res => {
                if (res && res.code == 200) {
                  this.$message.success(res.msg);
                  this.$refs.tables.reloadData();
                }
              });
          })
          .catch(() => {
            // this.$message({
            //   type: 'info',
            //   message: '已取消删除'
            // });
          });
      }
    }
  },

  mounted() {
    this.getStatusInfo();
  }
};
</script>
<style lang="scss" scoped>
#app-center {
  width: 100%;
  // height: 100%;
  background-color: #f1f1f1;
}
.center-box {
  .center-list {
    //max-width: 1200px;
    margin: 0 auto;
    width: 98%;
    padding-top: 20px;
    .center-left {
      background-color: #fff;
      border-top: 2px solid #b60205;
      padding-top: 30px;
      overflow: hidden;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Hospital/cfproject/apply/list.vue